var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep4Psp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "step_3_PSP_closed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.7701507,88.166 L36.7211507,88.1664499 L36.7211507,86.6840052 L74.7701507,86.684 L74.7701507,44.785 L36.7211507,44.7854356 L36.7211507,43.3029909 L74.7701507,43.302 L74.7701507,1.482 L36.7211507,1.48244473 L36.7211507,0 L115.78882,0 L115.78882,1.48244473 L77.7391507,1.482 L77.7391507,43.302 L115.78882,43.3029909 L115.78882,44.7854356 L77.7391507,44.785 L77.7391507,86.684 L115.78882,86.6840052 L115.78882,88.1664499 L77.7391507,88.166 L77.7394573,129.986996 L115.78882,129.986996 L115.78882,174.772432 L36.7211507,174.772432 L36.7211507,129.986996 L74.7705132,129.986996 L74.7701507,88.166 Z M114.304151,131.469 L38.2051507,131.469 L38.2051507,173.289 L114.304151,173.289 L114.304151,131.469 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 79.0676692,
    height: 174.772432,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888888",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PSP_closed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Line",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "square",
    points: "8 225 8 1 240 1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(129.363354, 90.886216) scale(-1, 1) translate(-129.363354, -90.886216) translate(7.555083, 1.000000)",
    stroke: "#000100"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Track",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    x: 0.25,
    y: 0.25,
    width: 234.671625,
    height: 4.72756827
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bed",
    transform: "translate(134.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.5,
    fill: "#DCD7BE",
    x: 0.25,
    y: 155.204486,
    width: 109.116541,
    height: 2.46488947
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.5,
    fill: "#DCD7BE",
    x: 0.25,
    y: 0.25,
    width: 109.116541,
    height: 2.46488947
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.191713,2.90279584 C104.974295,2.90279584 105.682764,3.21323357 106.195441,3.71598754 C106.706332,4.2169908 107.022638,4.9090998 107.022638,5.67409191 L107.022638,5.67409191 L107.022638,152.245284 C107.022638,153.010276 106.706332,153.702385 106.195441,154.203388 C105.682764,154.706142 104.974295,155.01658 104.191713,155.01658 L104.191713,155.01658 L3.16083173,155.01658 C2.3780779,155.01658 1.66906222,154.706019 1.15592338,154.203101 C0.644773384,153.702133 0.328130108,153.010147 0.328130108,152.245284 L0.328130108,152.245284 L0.328130108,5.67409191 C0.328130108,4.90922846 0.644773384,4.21724257 1.15592338,3.71627437 C1.66906222,3.21335695 2.3780779,2.90279584 3.16083173,2.90279584 L3.16083173,2.90279584 Z",
    id: "Stroke-11",
    strokeWidth: 0.5,
    fill: "#C1BC9F"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.5,
    fill: "#E0E4E3",
    x: 107.210118,
    y: 0.25,
    width: 1,
    height: 157.419376
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.5,
    fill: "#E0E4E3",
    x: 108.382069,
    y: 0.25,
    width: 1,
    height: 157.419376
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.250082, 7.785424)",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.4021031,51.8687784 C99.4021031,51.8687784 100.353519,79.6928876 100.298265,84.5099376 C100.241283,89.3252896 99.6542025,103.773044 99.799246,106.890458 C99.9442895,110.007872 99.4210969,115.74011 99.6921901,119.178435 C99.9632833,122.615061 100.391507,129.057038 99.9460162,132.351037 C99.5039789,135.646735 101.063197,139.796495 96.66009,141.387463 C92.2552568,142.978431 91.3521882,140.97826 88.409877,141.907032 C85.4675658,142.835804 80.3979498,141.845906 74.6169299,141.851 C68.83591,141.854396 64.0011263,142.375663 61.5561071,142.1804 C59.1093613,141.985137 54.8219442,141.652341 49.6314586,141.764405 C44.4426996,141.876469 38.4216673,141.056365 34.0720887,141.496131 C29.7225101,141.932501 23.811987,142.212661 21.2219243,142.168515 C18.6335884,142.124368 13.2963325,142.24662 11.8907919,142.090409 C10.4852512,141.934199 8.00569783,142.387549 6.19956078,141.435005 C4.39687716,140.482462 3.21408187,139.626701 2.77722463,137.047534 C2.33864068,134.468366 2.62527428,130.790632 2.39907548,125.893779 C2.17460338,120.998624 1.24563423,115.133946 1.54780821,111.828061 C1.84998219,108.520478 2.35418106,105.543993 2.16942325,101.530068 C1.98639215,97.5161423 2.02955987,89.5630009 2.07100087,86.3386168 C2.11071516,83.1142326 2.06927416,79.9170154 2.14352262,77.2886075 C2.21777109,74.6601995 2.00193253,52.5055051 2.00193253,52.5055051",
    id: "Fill-13",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4442347,42.113955 L99.4442347,31.4356233 C99.4442347,31.4356233 99.0332781,23.1327067 99.0332781,21.152911 C99.0332781,19.1748133 99.330272,9.50335872 99.5737379,7.75278469 C99.8189305,6.00221066 99.5392037,1.67926064 99.2560235,1.11894111 C98.9745701,0.560319524 97.4619734,0.112063905 95.7456252,0.0560319524 C94.0310037,0.00169793795 5.41977925,-3.55271368e-15 5.41977925,-3.55271368e-15 C5.41977925,-3.55271368e-15 3.56529437,0.684268995 3.11635017,1.90169051 C2.66740597,3.12080996 2.86770415,11.5273008 2.73647431,13.3661676 C2.60351776,15.2050344 2.36177857,20.5144863 2.4688345,22.7472748 C2.572437,24.9783652 3.94171681,30.0331265 3.10598992,33.2982612 C2.27026302,36.5633959 3.10598992,42.499387 3.10598992,42.499387",
    id: "Fill-17",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8933387,6.2939164 C91.8933387,6.2939164 93.0087923,4.36675683 90.2426054,4.90500316 C87.472965,5.44324949 78.7306401,4.25299498 75.3307512,4.90500316 C71.9291355,5.55531339 66.0445131,5.23610106 62.4201521,5.11894334 C58.7940643,5.00008768 56.0037034,4.8218042 54.2666347,4.68427122 C52.5312927,4.54504031 51.0739508,4.21224447 51.4728205,6.2803329 C51.8716901,8.34672339 53.394647,10.9190994 53.3065848,13.9346372 C53.2185227,16.950175 52.790299,20.64319 52.8939015,21.9319249 C52.997504,23.2206599 52.7505847,25.5502307 52.2999138,28.1124191 C51.8526963,30.6729095 51.8026218,31.1687074 51.5919633,32.0720104 C51.3813049,32.9753134 51.4590068,34.0619937 54.6689578,33.5101638 C57.8823622,32.9566361 62.1697793,32.2774609 64.1434071,32.7817485 C66.1170349,33.286036 70.7221663,32.9107918 72.7579556,32.8972082 C74.7937448,32.8870206 80.7025412,33.50507 82.1374359,33.533935 C83.5723306,33.561102 89.0822573,33.8174906 90.1631768,33.8752205 C91.2440963,33.9329504 92.9967054,34.5221349 91.9814008,31.4183043 C90.9643695,28.3127758 91.2958976,25.0815999 91.2699969,22.9065413 C91.2406429,20.7297849 90.9505559,16.2760936 91.3010777,13.2452744 C91.6515995,10.2161531 91.8933387,6.2939164 91.8933387,6.2939164",
    id: "Fill-21",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7271182,6.29306743 C49.7271182,6.29306743 50.8442986,4.36590786 48.0763849,4.90415419 C45.3084713,5.44240052 36.5661464,4.25214602 33.1645307,4.90415419 C29.762915,5.55446443 23.8800193,5.23525209 20.2556583,5.11809437 C16.6295705,4.99923871 13.8392097,4.82095523 12.102141,4.68342226 C10.3650723,4.54419134 8.90945703,4.2113955 9.30832669,6.27948393 C9.70719634,8.34587442 9.32904719,11.751938 9.24271177,14.7691737 C9.15292293,17.7847115 9.13565584,21.8937213 9.23925835,23.1841542 C9.33940744,24.4728891 10.5843642,25.5493818 10.13542,28.1115701 C9.68820255,30.6720606 9.63640129,31.1661605 9.42574286,32.0711614 C9.21681114,32.9727665 9.29278631,34.0611447 12.504464,33.5076169 C15.7178685,32.9557871 20.0035589,32.2766119 21.9789133,32.7808995 C23.9525411,33.2851871 28.5559458,32.9099428 30.5917351,32.8963593 C32.6275244,32.8861717 38.5380474,33.5042211 39.9729421,33.533086 C41.4078369,33.560253 46.9177635,33.8166416 47.998683,33.8743715 C49.0796025,33.9321014 50.8322116,34.5212859 49.816907,31.4157574 C48.7998758,28.3119268 49.1314038,25.0807509 49.1037765,22.9056924 C49.0761491,20.7289359 48.7860621,16.2752447 49.1365839,13.2444254 C49.4871057,10.2136062 49.7271182,6.29306743 49.7271182,6.29306743",
    id: "Fill-25",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4711714,58.675472 C99.4711714,58.675472 101.123631,60.1204172 101.62265,58.0370474 C102.123396,55.9519796 102.209731,50.46764 102.264986,47.5998228 C102.321967,44.7337035 102.166563,42.52978 102.171743,38.5701887 C102.17865,34.6105974 101.912737,30.6374226 101.938638,29.5965867 C101.962812,28.5540528 101.961085,27.0310024 100.123867,26.6404767 C98.2849227,26.248253 96.4856925,26.1837314 94.676102,26.4570994 C92.8665116,26.7304674 90.1883867,26.3059829 87.924672,26.3637128 C85.6592305,26.4197448 81.7188818,26.521621 80.2891672,26.6065179 C78.8577259,26.6914148 77.5229802,26.5148293 74.5236876,26.1243035 C71.5209416,25.7337778 70.0463326,26.2329716 67.1523692,25.7813201 C64.2584059,25.3296686 58.3375226,24.8610377 54.675174,25.4485242 C51.0128253,26.0360108 46.7737561,27.37059 39.3989843,26.6217994 C32.0242124,25.8730087 27.489876,27.480956 24.0330057,25.9528118 C20.572682,24.4246677 17.6320975,25.1394995 14.1769538,25.3568356 C10.7200835,25.5758696 9.49930064,25.7269861 7.40653,26.0546881 C5.31548606,26.3806922 1.18692614,26.2363675 1.18692614,26.2363675 C1.18692614,26.2363675 -0.218614543,27.1549519 0.12500044,28.436895 C0.468615423,29.7205361 0.219969405,38.4496351 0.119820315,43.3923325 C0.0196712243,48.333332 -0.0217697786,57.1218588 0.0213979328,57.3646639 C0.068019061,57.6057711 -0.70209291,59.8861018 3.96174663,59.0218514 C8.62903958,58.157601 12.2464938,57.2288289 17.2090539,57.4410711 C21.4740238,57.6244484 28.8885099,59.5397225 31.8688087,58.6737741 C34.8491075,57.8078257 44.6447245,59.2171142 49.2205019,58.374937 C53.2091985,57.6397299 64.6676358,57.8621598 68.1020589,57.7093453 C71.536482,57.5582289 74.2353273,58.0217659 78.5331047,57.4427691 C80.8434406,57.1320464 87.1977277,58.0438391 90.0312563,58.3698432 C92.8682383,58.6941494 99.4711714,58.675472 99.4711714,58.675472",
    id: "Fill-29",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.624187256,
    x: 0.312093628,
    y: 0.312093628,
    width: 108.992354,
    height: 157.295189
  })), /*#__PURE__*/React.createElement("g", {
    id: "Main",
    transform: "translate(127.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.476726,0.312093628 L115.476726,174.460338 L37.0332443,174.460338 L37.0332443,0.312093628 L115.476726,0.312093628 Z",
    id: "Fill-1",
    strokeWidth: 0.624187256,
    fill: "#E4E0C9"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    mask: "url(#mask-2)",
    strokeDasharray: "3.745123537061119,0.9362808842652797",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0340979,0.312093628 L37.0340979,174.460338 L0.312093628,174.460338 L0.312093628,0.312093628 L37.0340979,0.312093628 Z",
    id: "Fill-4",
    strokeWidth: 0.624187256,
    fill: "#DCD7BE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(67.852814, 137.852814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    transform: "translate(60.000000, 60.000000) rotate(-45.000000) translate(-60.000000, -60.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,0 L72,107 L48,107 L0,0",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.25,
    fill: "url(#linearGradient-3)",
    strokeDasharray: "6,4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(48.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2192236,0 C16.6780912,0 17.0780743,0.312297374 17.1893661,0.757464375 L17.8106339,3.24253563 C17.9219257,3.68770263 18.3219088,4 18.7807764,4 L23,4 C23.5522847,4 24,4.44771525 24,5 L24,17 C24,17.5522847 23.5522847,18 23,18 L1,18 C0.44771525,18 0,17.5522847 0,17 L0,5 C0,4.44771525 0.44771525,4 1,4 L5.21922359,4 C5.67809124,4 6.07807434,3.68770263 6.18936609,3.24253563 L6.81063391,0.757464375 C6.92192566,0.312297374 7.32190876,0 7.78077641,0 L16.2192236,0 Z M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 C14.7614237,6 17,8.23857625 17,11 C17,13.7614237 14.7614237,16 12,16 C9.23857625,16 7,13.7614237 7,11 C7,8.23857625 9.23857625,6 12,6 Z M12,7 C9.790861,7 8,8.790861 8,11 C8,13.209139 9.790861,15 12,15 C14.209139,15 16,13.209139 16,11 C16,8.790861 14.209139,7 12,7 Z",
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8.5 C12.2761424,8.5 12.5,8.72385763 12.5,9 C12.5,9.27614237 12.2761424,9.5 12,9.5 C11.1715729,9.5 10.5,10.1715729 10.5,11 C10.5,11.2761424 10.2761424,11.5 10,11.5 C9.72385763,11.5 9.5,11.2761424 9.5,11 C9.5,9.61928813 10.6192881,8.5 12,8.5 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 18,
    y: 6,
    width: 3,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 2,
    y: 2,
    width: 3,
    height: 1,
    rx: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(135.852814, 30.852814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    transform: "translate(60.000000, 60.000000) rotate(-90.000000) translate(-60.000000, -60.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,0 L72,107 L48,107 L0,0",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 0.25,
    fill: "url(#linearGradient-3)",
    strokeDasharray: "6,4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(48.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2192236,0 C16.6780912,0 17.0780743,0.312297374 17.1893661,0.757464375 L17.8106339,3.24253563 C17.9219257,3.68770263 18.3219088,4 18.7807764,4 L23,4 C23.5522847,4 24,4.44771525 24,5 L24,17 C24,17.5522847 23.5522847,18 23,18 L1,18 C0.44771525,18 0,17.5522847 0,17 L0,5 C0,4.44771525 0.44771525,4 1,4 L5.21922359,4 C5.67809124,4 6.07807434,3.68770263 6.18936609,3.24253563 L6.81063391,0.757464375 C6.92192566,0.312297374 7.32190876,0 7.78077641,0 L16.2192236,0 Z M16.8404914,3.48507125 L16.219,1 L7.78077641,1 L7.15950859,3.48507125 C6.95001824,4.32303266 6.22907469,4.92559875 5.37986081,4.99358936 L5.21922359,5 L1,5 L1,17 L23,17 L23,5 L18.7807764,5 C17.9170256,5 17.1575961,4.44672576 16.8856709,3.63935743 L16.8404914,3.48507125 Z",
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 C14.7614237,6 17,8.23857625 17,11 C17,13.7614237 14.7614237,16 12,16 C9.23857625,16 7,13.7614237 7,11 C7,8.23857625 9.23857625,6 12,6 Z M12,7 C9.790861,7 8,8.790861 8,11 C8,13.209139 9.790861,15 12,15 C14.209139,15 16,13.209139 16,11 C16,8.790861 14.209139,7 12,7 Z",
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8.5 C12.2761424,8.5 12.5,8.72385763 12.5,9 C12.5,9.27614237 12.2761424,9.5 12,9.5 C11.1715729,9.5 10.5,10.1715729 10.5,11 C10.5,11.2761424 10.2761424,11.5 10,11.5 C9.72385763,11.5 9.5,11.2761424 9.5,11 C9.5,9.61928813 10.6192881,8.5 12,8.5 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 18,
    y: 6,
    width: 3,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 2,
    y: 2,
    width: 3,
    height: 1,
    rx: 0.5
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4Psp);
export default __webpack_public_path__ + "static/media/step_4_PSP.c428c5f8c5b3b7c4140f37c4ad8bf49a.svg";
export { ForwardRef as ReactComponent };